import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { ChipModule } from 'primeng/chip';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { LeadService } from 'src/app/private/services/lead.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-add-lead-field',
  imports: [SharedModule,ChipModule],
  templateUrl: './add-lead-field.component.html',
  styleUrl: './add-lead-field.component.scss'
})
export class AddLeadFieldComponent {

  @Input() formAction: string = 'Add';
  @Output() closeDialog = new EventEmitter<any>();
  @Output() reload = new EventEmitter<any>();
  @Input() editLeadFieldData: any;
  @Input() dataSource: any[] = [];
  @Input() moduleType: string = 'lead';

  uniqueNameContainer: any[] = [];
  uniqueName: any;
  isUniquefname: boolean = true;
  isFixedField: boolean = false;
  selectedModules: string[] = [];

  moduleOptions = [
    { label: 'Lead', value: 'lead' },
    { label: 'Registration', value: 'registration' },
    { label: 'Application', value: 'application' },
    { label: 'Enrollment', value: 'enrollment' },
    { label: 'Admission', value: 'admission' },
    { label: 'Student', value: 'student' }
  ];

  @ViewChild('SaveleadForm', { static: false }) SaveleadForm!: NgForm;
  
  btnLoading = false;
  isSubmitted = false;
  leadsFeild: any = {
    field_name: '',
    type: '',
    options: '',
    data: [],
    label: '',
    required: '',
    placeholder: '',
    sequence: null,
    'min-length': null,
    'max-length': null,
    isEmail: false,
    isMany: false,
    isPublic: false,
    isVisibleTable: false
  };

  constructor(
    private localStorage: LocalStorageService,
    private api : LeadService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    if (this.formAction == 'Edit') {
      this.leadsFeild = this.editLeadFieldData;
      this.uniqueName = this.editLeadFieldData.field_name;
      this.isFixedField = this.editLeadFieldData.is_fixed || false;
      // For edit, set the current module as selected
      this.selectedModules = [this.moduleType];
    }else{
      this.createUniqueNameContainer();
      // For add, default to current module
      this.selectedModules = [this.moduleType];
    }
  }

  // ngOnChanges() {
  //   if (this.editLeadFieldData) {
  //     this.leadsFeild = this.editLeadFieldData;
  //     this.uniqueName = this.editLeadFieldData.field_name;
  //   }
  //   this.createUniqueNameContainer();
  // }



  fieldTypes = [
    { label: 'Text', value: 'text' },
    { label: 'Textarea', value: 'textarea' },
    { label: 'Email', value: 'email' },
    { label: 'Address', value: 'address' },
    { label: 'Number', value: 'number' },
    { label: 'Select', value: 'select' }
  ];

  booleanOptions = [
    { label: 'True', value: true },
    { label: 'False', value: false }
  ];

  addOption(option: string, type: string) {
    if (option.trim()) {
      this.leadsFeild.data.push(option);
      this.leadsFeild.options = '';
    }
  }

  removeOption(index: number, type: string) {
    this.leadsFeild.data.splice(index, 1);
  }

  SaveLead(valid: boolean) {
    this.isSubmitted = true;
    if (!valid) return;
    
    // Check if at least one module is selected
    if (!this.selectedModules || this.selectedModules.length === 0) {
      this.messageService.add({ 
        severity: 'error', 
        summary: 'Error', 
        detail: 'Please select at least one module' 
      });
      return;
    }
    
    this.btnLoading = true;
    
    if(this.formAction == 'Add'){

      // Check if field_name already exists in any of the selected modules
      const fieldExists = this.dataSource.some((field: any) => 
        field.field_name === this.leadsFeild.field_name
      );

      if(fieldExists){
        this.messageService.add({ 
          severity: 'error', 
          summary: 'Error', 
          detail: `Field "${this.leadsFeild.field_name}" already exists in one or more modules` 
        });
        this.btnLoading = false;
        return;
      }

      // Create an array of fields, one for each selected module
      const fieldsArray = this.selectedModules.map(moduleType => ({
        ...this.leadsFeild,
        module_type: moduleType
      }));

      let param = {
        organization_id: this.localStorage.getOrganizationId(),
        fields: fieldsArray,
      };

      this.api.addLeadField(param).subscribe({
        next: (data: any) => {
          this.btnLoading = false;
          this.reload.emit();
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Lead Field Added Successfully' });
          this.closeDialog.emit();
        },
        error: (error: any) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: (error.error.message || 'Something went wrong') });
          this.btnLoading = false;
        }
      });
    }else{
      // For fixed fields, only allow label updates
      const fieldToUpdate = this.isFixedField 
        ? { ...this.leadsFeild, field_name: this.uniqueName, type: this.editLeadFieldData.type }
        : this.leadsFeild;

      let param = {
        organization_id: this.localStorage.getOrganizationId(),
        module_type: this.moduleType,
        fields: [fieldToUpdate],
      };

      this.api.updateLeadField(param).subscribe({
        next: (data: any) => {
          this.btnLoading = false;
          this.reload.emit();
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Lead Field Updated Successfully' });
          this.closeDialog.emit();
        },
        error: (error: any) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: (error.error.message || 'Something went wrong') });
          this.btnLoading = false;
        }
      });
    }
  }
  
  handleCloseDialog() {
    this.closeDialog.emit();
  }

  createUniqueNameContainer() {
    this.uniqueNameContainer = [];
    this.dataSource.forEach((element: any) => {
      this.uniqueNameContainer.push(element.field_name);
    });
  }

  isUniqueName(name: any, form: any) {

    this.isUniquefname = !this.uniqueNameContainer.includes(name);
    console.log("isUniquefname", this.isUniquefname);
    return this.isUniquefname;

}



}
